import { TagDataLayer } from '@axa-fr-axion/tag';
import { StepNavigationPath, TechNavigationPath } from 'interfaces';
import { Preset } from 'presets';
import { DATA_LAYER_GLOBAL_MRH, NAVIGATION_DATA_DEVIS_MRH } from './tags/DevisMRH.tag';
import { DATA_LAYER_GLOBAL_PP, NAVIGATION_DATA_DEVIS_PP } from './tags/DevisPP.tag';

export const DATA_LAYER_GLOBAL = (preset: Preset | undefined): Omit<TagDataLayer, 'xiti_xtpage'> => {
    if (preset === 'DevisMRH') {
        return DATA_LAYER_GLOBAL_MRH;
    }
    if (preset === 'DevisPP') {
        return DATA_LAYER_GLOBAL_PP;
    }
    return DATA_LAYER_GLOBAL_MRH;
};

// eslint-disable-next-line max-len
export const NAVIGATION_DATA = (preset: Preset | undefined): Record<StepNavigationPath | TechNavigationPath, TagDataLayer | null> => {
    if (preset === 'DevisMRH') {
        return NAVIGATION_DATA_DEVIS_MRH;
    }
    if (preset === 'DevisPP') {
        return NAVIGATION_DATA_DEVIS_PP;
    }
    return NAVIGATION_DATA_DEVIS_MRH;
};
